const steps = [
  {
    number: "01",
    title: "Get clear on the problem",
    description:
      "Start with the people using the software, the workflow, and what a useful first delivery needs to accomplish.",
  },
  {
    number: "02",
    title: "Build in visible steps",
    description:
      "Break the work into focused pieces, share progress, and make room to adjust as the product takes shape.",
  },
  {
    number: "03",
    title: "Ship and hand it over",
    description:
      "Bring the work to a usable finish with a deployment and the notes your team needs to keep moving.",
  },
];

export default function Approach() {
  return (
    <section className="approach section" id="approach">
      <div className="section-wrap">
        <div className="section-heading section-heading--light">
          <div>
            <p className="eyebrow">Working together</p>
            <h2>Clear communication. Useful progress.</h2>
          </div>
          <p className="section-heading__aside">
            A straightforward path from the first conversation to software your team can use.
          </p>
        </div>
        <div className="approach-grid">
          {steps.map((step) => (
            <article className="approach-step" key={step.number}>
              <span>{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
